import React, { createContext, useContext, useEffect, useState } from "react";
import { Layout } from "antd";
import { Content } from "antd/es/layout/layout";
import { InviteModalProvider } from "@components/ModalContext/InviteModalContext";
import SuperAdminRouting from "../../../superadmin-roter-service";
import { useLocation } from "react-router-dom";
import { useStore } from "@stores/root-store";
import { constRoute } from "@utils/route";
import { onMasterLogOutClearAll } from "@utils/common-functions";
import MasterAdminHeader from "@components/common-components/MasterHeader/MasterAdminHeader";
import SideBar from "./sideBar/SideBar";
import style from "./superadmin-layout.module.scss";

const UserContext = createContext(null);

const SuperAdminLayout = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const email = searchParams.get("email");

  const [userDetails, setUserDetails] = useState(null);
  const {
    user: { getUserDetails, loadMasterAdminInfo, receiveAllUsers },
  } = useStore(null);

  useEffect(() => {
    (async () => {
      const user = await loadMasterAdminInfo();
      if (user?.status === 401) {
        onMasterLogOutClearAll(constRoute.masteradminLogin);
      }
    })();
  }, []);

  const updateUserDetails = async () => {
    if (email) {
      const userData = await getUserDetails({ email });
      setUserDetails(userData);
    }
  };

  useEffect(() => {
    updateUserDetails();
  }, [email]);

  useEffect(() => {
    (async () => {
      await receiveAllUsers();
    })();
  }, []);

  return (
    <UserContext.Provider value={{ userDetails, updateUserDetails }}>
      <Layout className={style.layout}>
        <InviteModalProvider>
          <div className={style.layoutHeader}>
            <MasterAdminHeader />
          </div>
          <div className={style.layoutSidebar}>
            <SideBar />
          </div>
          <Content className={style.layoutContent}>
            <SuperAdminRouting />
          </Content>
        </InviteModalProvider>
      </Layout>
    </UserContext.Provider>
  );
};

export function useUserContext() {
  return useContext(UserContext);
}

export default SuperAdminLayout;
